import { carouselData } from '@/mocks/homeData';

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-16 md:py-24 bg-background-100">
      <div className="px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="text-center mb-12">
          <span className="text-xs font-medium tracking-widest uppercase text-primary-500 bg-primary-50 px-3 py-1 rounded-full">
            焦点专题
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-black text-foreground-950 mt-4">
            焦点专题
          </h2>
          <p className="text-sm text-foreground-600 mt-2">深度策划的大型瓜料专题，一次看过瘾</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {carouselData.map((item, i) => (
            <div
              key={i}
              className={`bg-background-50 rounded-lg overflow-hidden border border-background-200/70 group cursor-pointer hover:border-primary-200 transition-colors duration-200 ${
                i === 0 ? 'lg:col-span-2 lg:row-span-2' : ''
              }`}
            >
              <div
                className={`overflow-hidden bg-background-200 ${
                  i === 0 ? 'aspect-[16/7]' : 'aspect-[16/10]'
                }`}
              >
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                  onError={(e) => {
                    (e.target as HTMLElement).style.display = 'none';
                  }}
                />
              </div>
              <div className="p-5">
                <span className="text-xs font-bold text-primary-500 bg-primary-50 px-2.5 py-1 rounded-full mb-3 inline-block">
                  {item.tag}
                </span>
                <h3
                  className={`font-heading font-bold text-foreground-950 leading-snug mb-2 group-hover:text-primary-500 transition-colors duration-200 ${
                    i === 0 ? 'text-xl md:text-2xl' : 'text-base'
                  }`}
                >
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">{item.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}